import type { ConversionsEventMeta } from '@dfh-corp-sites/www-api'
import * as R from 'ramda'

import { Maybe } from '../../utils/types'
import { CartItem } from '../cart/state/types'

type CartItemForConversions = CartItem & {
  product: { sku: NonNullable<CartItem['product']['sku']> }
  prices: {
    price: {
      currency: NonNullable<NonNullable<CartItem['prices']>['price']['currency']>
      value: NonNullable<NonNullable<CartItem['prices']>['price']['value']>
    }
  }
}

type ConversionsEventItems = Extract<
  ConversionsEventMeta,
  { event_name: 'Purchase' }
>['custom_data']['contents']

function isCartItemForConversions(value: Maybe<CartItem>): value is CartItemForConversions {
  return (
    !!value &&
    !!value.product.sku &&
    !!value.prices?.price?.currency &&
    typeof value.prices.price.value === 'number'
  )
}

const conversionsEventItemReducer = (acc: ConversionsEventItems, cartItem: Maybe<CartItem>) =>
  isCartItemForConversions(cartItem)
    ? R.append(
        {
          id: cartItem.product.sku,
          price: cartItem.prices.price.value,
          quantity: cartItem.quantity,
        },
        acc,
      )
    : acc

export const conversionsEventItemsFromCartItems = (
  cartItems: Maybe<CartItem>[],
): ConversionsEventItems => R.reduce(conversionsEventItemReducer, [], cartItems)
